import { Editor, Node, ObjectNode, Widget } from '@sagold/react-json-editor';

import { ObjectOptions } from './ObjectWidget';

export type ObjectPropertiesProps = {
  node: ObjectNode<ObjectOptions>;
  options: ObjectOptions;
  editor: Editor;
};

export function createWidgetForChildNode(
  parentNode: ObjectNode<ObjectOptions>,
  options: ObjectOptions,
  child: Node,
  editor: Editor
): JSX.Element | null {
  return !child.options.hidden ? (
    <div key={child.id} className="rje-object__property">
      <Widget
        node={child}
        editor={editor}
        options={{
          ...child.options,
          disabled:
            options.disabled ||
            child.options.disabled ||
            parentNode.options.disabled,
          readOnly:
            options.readOnly ||
            child.options.readOnly ||
            parentNode.options.readOnly,
          isOptional: parentNode.optionalProperties.includes(child.property),
        }}
      />
    </div>
  ) : null;
}

export function ObjectProperties({
  node,
  editor,
  options,
}: ObjectPropertiesProps) {
  return (
    <div
      className="rje-object__properties"
      style={{ boxShadow: 'none', border: 0 }}
    >
      {node.children.map((child) =>
        createWidgetForChildNode(node, options, child, editor)
      )}
    </div>
  );
}
